import { Components } from "@mui/material/styles";
import TYPOGRAPHY from "../../../theme/typography";

export const MuiTypography: Components["MuiTypography"] = {
    defaultProps: {
        lineHeight: TYPOGRAPHY.lineHeights.base,
    },
};
